import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { pure } from 'recompose'
import { pluralize } from 'utils'
import { HeartFilledIcon, HeartOutlineIcon } from 'components/icons/basic'
import SrStatusMessage from 'components/sr-status-message'

const propTypes = {
  toggleLike: PropTypes.func.isRequired,
  isLikedbyUser: PropTypes.bool.isRequired,
  likeCount: PropTypes.number.isRequired,
  likeableType: PropTypes.string.isRequired,
  likeableId: PropTypes.number.isRequired,
}

const defaultProps = {}

function LikeButton({
  toggleLike,
  isLikedbyUser,
  likeCount,
  likeableType,
  likeableId,
}) {
  const [liked, setLiked] = useState(isLikedbyUser)
  const [currentLikeCount, setCurrentLikeCount] = useState(likeCount)
  const [statusMessage, setStatusMessage] = useState('')

  const handleLikeClick = () => {
    const nextLiked = !liked
    const countChangeBy = liked ? -1 : 1
    const nextLikeCount = currentLikeCount + countChangeBy

    setLiked(nextLiked)
    setCurrentLikeCount(nextLikeCount)
    setStatusMessage(
      nextLiked
        ? `Liked. ${nextLikeCount} ${pluralize('Like', nextLikeCount)}.`
        : `Unliked. ${nextLikeCount} ${pluralize('Like', nextLikeCount)}.`
    )
    toggleLike()
  }

  const likesCopy = `${currentLikeCount} ${pluralize('Like', currentLikeCount)}`

  return (
    <div
      role="region"
      id={`like-button-region-${likeableType}-${likeableId}`}
      aria-live="polite"
      aria-atomic="true"
    >
      <button
        type="button"
        className="link-primary like-button"
        onClick={handleLikeClick}
        aria-controls={`like-button-region-${likeableType}-${likeableId}`}
      >
        <React.Fragment>
          {liked ? (
            <HeartFilledIcon aria-label={`Unlike ${likeableType}.`} />
          ) : (
            <HeartOutlineIcon aria-label={`Like ${likeableType}.`} />
          )}
          {currentLikeCount > 0 ? likesCopy : 'Like'}
        </React.Fragment>
      </button>
      <SrStatusMessage message={statusMessage} />
    </div>
  )
}

LikeButton.propTypes = propTypes
LikeButton.defaultProps = defaultProps

export default pure(LikeButton)
